module.exports = __webpack_public_path__ + "img/TV_clean_box09.05049154.jpg";